function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCurrentLocationOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.862 4.753a1.1 1.1 0 011.385 1.385l-7.245 22.4a1.1 1.1 0 01-2.078.045l-3.93-10.577-10.577-3.93a1.1 1.1 0 01.045-2.078l22.4-7.245zm-18.71 8.364l7.655 2.844a2.102 2.102 0 011.233 1.233l2.843 7.654 5.608-17.34-17.339 5.609z",
    fill: props.color
  }));
}

export default SvgIconCurrentLocationOutline;